module.exports = __webpack_public_path__ + "img/first_zhCn.3eea7bd1.png";